import { RecurringMeetingMapping } from '@/types/RecurringMeetingMapping';
import { queryApi } from '@/utility/queryApi';

export const getRecurringMeetingsAssociation = () =>
  queryApi<RecurringMeetingMapping[]>({
    method: 'GET',
    path: '/api/recurring-meeting-association',
  });
